import React, { RefObject, useEffect, useRef } from "react";
import PSPDFKit, { ViewState } from "pspdfkit";
import pspdfkitLib from "pspdfkit";
import { Instance as PSPDFInstance } from "pspdfkit";
import "./PdfViewerComponent.css";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { saveEditDocument } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { fonts } from "../../../assets/data/font";
import { blob } from "stream/consumers";

const PdfViewerComponent = (props: any) => {
  const dispatch = useAppDispatch();
  const saveLoading = useSelector((state: RootState) => state.engageTranslationState.engageTranslationDetailPageState.loadingSave);
  const saveDocs = async (instance: PSPDFInstance) => {
    const arrayBuffer = await instance.exportPDF();
    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
    await dispatch(saveEditDocument({ documentId: props.documentId, docId: props.docId, file: blob }));
  };

  useEffect(() => {
    const container = props.refContainer.current;

    let instance: PSPDFInstance;
    (async function () {
      if (container) {
        instance = await PSPDFKit.load({
          // Container where PSPDFKit should be mounted.
          container,
          toolbarItems: props.editable ? [{ type: "content-editor" }, { type: "zoom-in" }, { type: "zoom-out" }, { type: "pan" }, { type: "pager" }, { type: "search" }, { type: "zoom-mode" }] : [{ type: "zoom-in" }, { type: "zoom-out" }, { type: "pan" }, { type: "pager" }, { type: "search" }, { type: "zoom-mode" }],
          customFonts: props.customFonts,
          // The document to open.
          document: props.document,
          // Use the public directory URL as a base URL. PSPDFKit will download its library assets from here.
          baseUrl: `${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}`,
        });
        if (props.editable) {
          instance.addEventListener("viewState.change", (viewState, previousState) => {
            if (previousState.interactionMode === "CONTENT_EDITOR" && viewState.interactionMode === null) {
              saveDocs(instance);
            }
          });
          instance.setViewState((v) => v.set("interactionMode", PSPDFKit.InteractionMode.CONTENT_EDITOR));
          // instance.addEventListener("document.saveStateChange", (event) => {
          //   console.log(`Save state changed: ${event.hasUnsavedChanges}`);
          // });
        }
        instance.setViewState((viewState: any) =>
          viewState.set("viewportPadding", {
            horizontal: viewState.viewportPadding.horizontal,
            vertical: viewState.viewportPadding.vertical + 20,
          })
        );
      }
    })();

    return () => {
      container && PSPDFKit.unload(container);
    };
  }, []);

  return (
    <div className="pdf-viewer-container">
      <div
        className="pdf-viewer"
        ref={props.refContainer}
      />
      {props.editable && saveLoading && (
        <div
          id="spinner"
          style={{ position: "absolute", top: 0, width: "100%", height: "100%", backgroundColor: "#8080807a", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Spin
            size="large"
            tip="Saving Document"
          />
        </div>
      )}
    </div>
  );
};

export default PdfViewerComponent;
